import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Collapse from '@mui/material/Collapse';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import IconButton from '@mui/material/IconButton';


import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';

import supportImage from '../../../assets/Gruppebillede_Web.jpg';

import flowCalDark from '../../../assets/dark1.png';
import flowCalDark2 from '../../../assets/dark2.png';
import flowCalLight from '../../../assets/light1.png';
import flowCalLight2 from '../../../assets/light2.png';

import { useTheme } from '@mui/material/styles';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Fade } from '@mui/material';

const SupportPage = () => {

    const [expanded, setExpanded] = React.useState(false);
    const [openSection, setOpenSection] = useState(null);
    const theme = useTheme();

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
    setExpandedAccordion(false); // Close any expanded accordion when a new section is opened
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  return (
    <Fade in={true} timeout={500}>
    <Container
      id="faq"
      maxWidth="xl"
      sx={{
        pt: 4,
        pb: 2,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
    <Typography
      component="h2"
      variant="h4"
      color="text.secondary"
      sx={{
        width: '100%',
        textAlign: 'center',
      }}
    >
      Support & FAQ
    </Typography>

    <Stack
      direction="row"
      spacing={2}
      alignItems="left"
      justifyContent="left"
      sx={{ padding: 2 }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column'}} >
          <Box sx={{ display: 'flex', flexDirection: 'row'}}>
            <LocalPhoneIcon
              sx={{
                fontSize: '40px',
                p: '5px',
                mr: 1,
              }}
            />
            <Typography variant="subtitle1" sx={{ p: '5px' }}>
            +45 30 64 16 27
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row'}}>
              <EmailRoundedIcon
              sx={{
                  // color: 'hsl(63, 100%, 40%)',
                  // border: '1px solid hsl(63, 100%, 40%)',
                  // borderRadius: '50%',
                  fontSize: '40px',
                  p: '5px',
                  mr: 1,
              }}
              />
            <Typography variant="subtitle1" sx={{ p: '5px' }}>
              <a href="mailto:support@remoni.com">support@remoni.com</a>
            </Typography>
          </Box>
        </Box>
      </Stack>

        <img
            srcSet={`${supportImage}`}
            src={`${supportImage}`}
            alt={'support image'}
            style={{
                padding: 4,
                maxWidth: '100%',
                margin: 'auto',
                display: 'block',
                borderRadius: 8      // This applies the border radius
              }}
            />
        <Box sx={{ width: '100%', my: 1 }}>
          <Box
            onClick={() => toggleSection('besparelsesoverblik')}
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              mb: 1,
            }}
          >
            <Typography variant="h6" sx={{ flexGrow: 1 }} color={openSection === 'besparelsesoverblik' ? 'text.primary' : 'text.secondary' }>
              Besparelsesoverblik
            </Typography>
            <IconButton sx={{ borderRadius: 1 }}>
              <AddRoundedIcon sx={{ color: openSection === 'besparelsesoverblik' ? 'text.primary' : 'text.secondary' }}/>
            </IconButton>
          </Box>

          <Collapse in={openSection === 'besparelsesoverblik'} timeout="auto" unmountOnExit>
          <Stack sx={{ gap: 1 }}>
            <Accordion
              elevation={0}
              variant='outlined'
              expanded={expanded === 'panel1'}
              onChange={handleChange('panel1')}
              sx={{ borderRadius: 1 }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography component="h3" variant="subtitle2">
                  Hvor ser jeg energibesparelsen for min bygning?  
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ maxWidth: { sm: '100%', md: '100%' } }}
                >
                  Under <b>Besparelsesoverblik</b> kan du trykke på den enkelte bygning og se det samlede forbrug med og uden vores optimering og dermed den samlede kWh- og CO2e-besparelse. Her har du selv mulighed for at indtaste CO2e-koefficienten for bygningen således den nøjagtige CO2-ækvivalente besparelse vises. 
                  <br></br><br></br>
                  Derudover kan du se det aflæste forbrug for den enkelte dag samt hvilke 9 dage vi aktivt styrer varmen i bygningen og den 10. dag, hvor vi slukker for vores optimering og bygningen derfor kører sin normale drift.  
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              elevation={0}
              variant='outlined'
              expanded={expanded === 'panel2'}
              onChange={handleChange('panel2')}
              sx={{ borderRadius: 1 }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography component="h3" variant="subtitle2">
                  Hvorfor kan jeg ikke se besparelsen lige nu? 
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ maxWidth: { sm: '100%', md: '100%' } }}
                >
                  Da besparelsen er baseret på forbruget med og uden vores optimering, kræver det tilstrækkeligt med dage med data fra bygningen, for at kunne se energibesparelsen. Der kan derfor i starten af optimeringsperioden eller varmesæsonen potentielt være for lidt data, til at kunne angive besparelsen. I takt med at der kommer flere aktive- og baseline-dage kommer der også mere sammenligningsdata, og besparelsen kan derfor angives.  
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              elevation={0}
              variant='outlined'
              expanded={expanded === 'panel3'}
              onChange={handleChange('panel3')}
              sx={{ borderRadius: 1 }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3d-content"
                id="panel3d-header"
              >
                <Typography component="h3" variant="subtitle2">
                  Hvor kommer energidataene fra? 
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ maxWidth: { sm: '100%', md: '100%' } }}
                >
                  Energidataene og kWh-forbruget kommer fra jeres egen afregningsmåler. Det er altså hovedmålerdata direkte fra måleren eller via en data-integration med jeres forsyningsselskab, som vi bruger.  
                </Typography>
              </AccordionDetails>
            </Accordion>

          </Stack>
          </Collapse>

        </Box>

        <Box sx={{ width: '100%', my: 1 }}>
          <Box
            onClick={() => toggleSection('kalender')}
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              mb: 1,
            }}
          >

            <Typography variant="h6" sx={{ flexGrow: 1 }} color={openSection === 'kalender' ? 'text.primary' : 'text.secondary' }>
              Kalender
            </Typography>

            <IconButton sx={{ borderRadius: 1 }}>
              <AddRoundedIcon sx={{ color: openSection === 'kalender' ? 'text.primary' : 'text.secondary' }}/>
            </IconButton>

          </Box>

          <Collapse in={openSection === 'kalender'} timeout="auto" unmountOnExit>
            <Stack sx={{ gap: 1 }}>
            <Accordion
              elevation={0}
              variant='outlined'
              expanded={expanded === 'panel4'}
              onChange={handleChange('panel4')}
              sx={{ borderRadius: 1 }}
            >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel4d-content"
              id="panel4d-header"
            >
              <Typography component="h3" variant="subtitle2">
                Hvordan opretter jeg en begivenhed i kalenderfunktionen? 
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: '100%', md: '100%' } }}
              >
                I kalenderoverblikket markerer du dagen og tidsperioden for begivenheden. Herefter navngiver du begivenheden eks. <i>elevsamtaler</i> og indtaster det nøjagtige start- og sluttidspunktet for begivenheden samt at bygningen er i brug. 
                <br></br><br></br>
                Til slut markerer du de blandesløjfer som dækker de bygningsdele, hvor begivenheden bliver afholdt og trykker <b>opret begivenhed</b>. Herefter ser du begivenheden fremgå i kalenderoverblikket. 
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            elevation={0}
            variant='outlined'
            expanded={expanded === 'panel5'}
            onChange={handleChange('panel5')}
            sx={{ borderRadius: 1 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel5d-content"
              id="panel5d-header"
            >
              <Typography component="h3" variant="subtitle2">
                Hvordan lægger jeg en ferie ind i kalenderfunktionen? 
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: '100%', md: '100%' } }}
              >
                I kalenderoverblikket markerer du de dage ferien finder sted. Herefter navngiver du ferien og indtaster start og sluttidspunkt for ferien samt at bygningen ikke er i brug.  
                <br></br><br></br>
                Til sidst markerer du de blandesløjfer, der dækker de bygningsdele, der ikke er i brug under ferien og trykker <b>opret begivenhed</b>. Herefter ser du ferien fremgå i kalenderoverblikket. 
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            elevation={0}
            variant='outlined'
            expanded={expanded === 'panel6'}
            onChange={handleChange('panel6')}
            sx={{ borderRadius: 1 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel6d-content"
              id="panel6d-header"
            >
              <Typography component="h3" variant="subtitle2">
                Hvor lang tid i forvejen skal jeg oprette en begivenhed? 
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: '100%', md: '100%' } }}
              >
                Når du opretter en begivenhed i kalenderen, vil styringen blive justeret inden for få minutter, så opvarmningen passer til begivenheden. Hvis begivenheden finder sted på en dag, hvor bygningen normalt ikke er i brug, som f.eks. i ferier eller weekender, anbefaler vi, at du opretter begivenheden senest dagen før, således komforttemperaturen sikres i tidsrummet for begivenheden. 
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            elevation={0}
            variant='outlined'
            expanded={expanded === 'panel7'}
            onChange={handleChange('panel7')}
            sx={{ borderRadius: 1 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel7d-content"
              id="panel7d-header"
            >
              <Typography component="h3" variant="subtitle2">
                Kan jeg lægge en begivenhed ind for en blandesløjfe, der forsyner et enkelt område i bygningen? 
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: '100%', md: '100%' } }}
              >
                Når du indtaster en begivenhed i kalenderfunktionen, kan du markere lige nøjagtigt den blandesløjfe, som forsyner det område, du gerne vil have varme på til begivenheden.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            elevation={0}
            variant='outlined'
            expanded={expanded === 'panel8'}
            onChange={handleChange('panel8')}
            sx={{ borderRadius: 1 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel8d-content"
              id="panel8d-header"
            >
              <Typography component="h3" variant="subtitle2">
                Navngivningen af de enkelte blandesløjfer giver ikke mening  
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: '100%', md: '100%' } }}
              >
                Vi har forsøgt at lave navngivningen af de enkelte blandesløjfer gennemskuelig. Skulle I have ønsker til at få ændret navnet, så det er nemmere at lave begivenheder, som kun gælder dele af bygningen, så ræk ud til vores support, så omdøber vi det sammen.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            elevation={0}
            variant='outlined'
            expanded={expanded === 'panel9'}
            onChange={handleChange('panel9')}
            sx={{ borderRadius: 1 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel9d-content"
              id="panel9d-header"
            >
              <Typography component="h3" variant="subtitle2">
              Hvordan ser jeg de begivenheder jeg har lagt ind for den kommende måned?  
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: '100%', md: '100%' } }}
              >
                Når du er inde i kalenderoverblikket, kan du oppe i højre hjørne skifte kalenderens visning mellem en måned, en uge eller en dag. 
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            elevation={0}
            variant='outlined'
            expanded={expanded === 'panel10'}
            onChange={handleChange('panel10')}
            sx={{ borderRadius: 1 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel10d-content"
              id="panel5d-header"
            >
              <Typography component="h3" variant="subtitle2">
                Hvordan sletter jeg en begivenhed?    
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: '100%', md: '100%' } }}
              >
                Hvis du fortryder en begivenhed i kalenderen, kan du altid slette den igen ved at trykke på den konkrete begivenhed og trykke <b>fjern begivenhed</b>. 
              </Typography>
            </AccordionDetails>
          </Accordion>
          </Stack>
          </Collapse>
        </Box>

        {/* <Box sx={{ width: '100%', my: 1 }}>
          <Box
            onClick={() => toggleSection('sensors')}
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              mb: 1,
            }}
          >

            <Typography variant="h6" sx={{ flexGrow: 1 }} color={openSection === 'sensors' ? 'text.primary' : 'text.secondary' }>
              Sensorer
            </Typography>

            <IconButton sx={{ borderRadius: 1 }}>
              <AddRoundedIcon sx={{ color: openSection === 'sensors' ? 'text.primary' : 'text.secondary' }}/>
            </IconButton>

          </Box>

          <Collapse in={openSection === 'sensors'} timeout="auto" unmountOnExit>

            <Accordion
              elevation={0}
              expanded={expanded === 'panel11'}
              onChange={handleChange('panel11')}
              sx={{boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%)"}}
            >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel11d-content"
              id="panel11d-header"
            >
              <Typography component="h3" variant="subtitle2">
                Hvordan kalibrerer jeg en ReMoni Flow Sensor? 
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: '100%', md: '100%' } }}
              >
                En ReMoni flow sensor - enten FlowMoniEnergy eller en FlowMoniVolume - kan kalibreres ved at indtaste en kalibreringsfaktor i enheden. Denne kalibreringsfaktor er en konstant, som ganges på det aflæste forbrug for at korrigere for eventuelle afvigelser i målingen.
                <br></br><br></br>
                Kalibreringsfaktoren kan oplyses på to måder:
                <br></br>
                <ol>
                  <li>
                    Kalibrerings faktoren indtastes manuelt som en tal værdi. Eksempelvis 1 hvis sensoren aflæser korrekt, 0.95 hvis sensoren aflæser 5% for lidt og 1.05 hvis sensoren aflæser 5% for meget.
                  </li>
                  <li>
                    Kalibrerings faktoren afledes på baggrund af en kontrolleret test og sammenlignes med det aflæste forbrug fra sensoren. Dette foregår ved hjælp af live data fra flow sensoren, hvori det er muligt med musen at markere data og periode som ligger til grund for den kontrollerede test. Herefter indtastes den kendte volumen i m³ hvilket resulterer i en kalibrerings faktor baseret på den kontrollerede test.
                  <br></br><br></br>
                  {theme.palette.mode === 'dark' ? (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                      <img
                        srcSet={`${flowCalDark}`}
                        src={`${flowCalDark}`}
                        alt={'support image'}
                        style={{
                          padding: 4,
                          maxWidth: '70%',
                          margin: 'auto',
                          display: 'block',
                          borderRadius: 8      // This applies the border radius
                        }}
                      />
                      <img
                        srcSet={`${flowCalDark2}`}
                        src={`${flowCalDark2}`}
                        alt={'support image'}
                        style={{
                          padding: 4,
                          maxWidth: '30%',
                          margin: 'auto',
                          display: 'block',
                          borderRadius: 8      // This applies the border radius
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <img
                      srcSet={`${flowCalLight}`}
                      src={`${flowCalLight}`}
                      alt={'support image'}
                      style={{
                        padding: 4,
                        maxWidth: '70%',
                        margin: 'auto',
                        display: 'block',
                        borderRadius: 8      // This applies the border radius
                      }}
                    />
                    <img
                      srcSet={`${flowCalLight2}`}
                      src={`${flowCalLight2}`}
                      alt={'support image'}
                      style={{
                        padding: 4,
                        maxWidth: '30%',
                        margin: 'auto',
                        display: 'block',
                        borderRadius: 8      // This applies the border radius
                      }}
                    />
                  </div>
                  )}
                  

                  </li>
                </ol>

              </Typography>
            </AccordionDetails>
          </Accordion>
          </Collapse>
        </Box> */}
    </Container>
  </Fade>
  )
}

export default SupportPage